import context from './LinkContext'

const { Consumer, Provider } = context

export { Consumer as LinkConsumer }
export { Provider as LinkProvider }
export default context
